import { POST_PAYMENT_AUTHORIZATION_DETAILS } from ".."
import { apiInstance } from "../config/apiInstance"

export const postPaymentAuthorizationDetail = async (id: string, richText: string) => {
    await apiInstance.post( `${POST_PAYMENT_AUTHORIZATION_DETAILS}/${id}`, {
        paymentAuthorizationDetail: richText
    });
}